// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1oeVI","image":"Header_image__1imJ1","name":"Header_name__1bgPc","info":"Header_info__26mue","infoRow":"Header_infoRow__Eb0q9"};